import i18next from "i18next";
import React, { ReactElement } from "react";
import { language } from "../stores/18nStore";
import ButtonOnClick from "./ButtonOnClick";

interface Props {
  closeCookies: (adds: boolean, socialNetworks: boolean) => void;
  setIsSocialNetwork: (value: React.SetStateAction<boolean>) => void;
  setIsAdds: (value: React.SetStateAction<boolean>) => void;
  setIsSettings: (value: React.SetStateAction<boolean>) => void;
}

export default function CookiesMain({
  setIsSocialNetwork,
  setIsSettings,
  setIsAdds,
  closeCookies,
}: Props): ReactElement {
  return (
    <>
      <div className="cookies-main-title">
        <h3 style={{ margin: 0 }}>{language("cookiesTitle")}</h3>
      </div>
      <div className="cookies-main-text">
        <p>
          {language("cookiesSubTitle1")}{" "}
          <a href="###">{language("cookiesSubTitle2")}</a>{" "}
          {language("cookiesSubTitle3")}
        </p>
        <p>
          {language("cookiesSubTitle4")}{" "}
          <a
            href={`https://sybel.co/${i18next.language.substr(
              0,
              2
            )}/cgu#personalData`}
          >
            {language("cookiesSubTitle5")}
          </a>
        </p>
        <p>{language("cookiesSubTitle6")}</p>
        <p style={{ marginTop: "30px" }}>{language("cookiesLast")}</p>
      </div>
      <div className="cookies-main-buttons">
        <ButtonOnClick
          cta="cookiesSettingsCTA"
          onClick={() => setIsSettings(true)}
          noClassName
        />
        <ButtonOnClick
          cta="cookiesAllowAll"
          onClick={() => {
            setIsSocialNetwork(true);
            setIsAdds(true);
            return closeCookies(true, true);
          }}
          noClassName
        />
      </div>
    </>
  );
}
